module.exports = __webpack_public_path__ + "img/Jimbo.a3f42eba.jpeg";